import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'shared';
export const keyPrefix = 'controlled_map';
export const useControlledMapTranslation = (): UseTranslationResponse<
  typeof namespace, typeof keyPrefix> => useTranslation(namespace, { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    select_area: 'Выберите зону на карте',
    location_unsupported: 'Геолокация не поддерживается браузером',
    location_unavailable: 'Не удалось определить местоположение',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    select_area: 'Select an area on the map',
    location_unsupported: 'Geolocation is not supported by the browser',
    location_unavailable: 'Unable to determine location',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    select_area: 'Seleccione un área en el mapa',
    location_unsupported: 'El navegador no admite la geolocalización',
    location_unavailable: 'No se pudo determinar la ubicación',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    select_area: 'Selecione uma área no mapa',
    location_unsupported: 'O navegador não oferece suporte à geolocalização',
    location_unavailable: 'Não foi possível determinar a localização',
  },
}) as Record<string, unknown>;
